<template lang="pug">
  Auth(@loggedIn="onLoggedIn" @loginFailed="loginFailed"
    :redirectWithLoginFailed="true")
    Header(:content="headerContent")
    div.wrap-home
      ModuleHome(:slides="slides")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-home {
  width: 100%;
  min-height: 100vh;
  background: $primary_bg_color;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header'
import ModuleHome from '@/components/module/ModuleHome'

export default {
  components: {
    Auth,
    Header,
    ModuleHome
  },
  data () {
    return {
      headerContent: {
        title: '',
        left: {
          icon: 'mdi-presentation-play',
          to: '/home',
          color: '#1f9ec4'
        },
        right: {
          icon: 'mdi-account',
          to: '/mypage'
        }
      },
      slides: []
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {
    this.slides = await database.slideCollection().getPublishedSlides()
    console.log('this.slides:', this.slides)
  },
  methods: {
    onLoggedIn () {
    
    },
    loginFailed () {

    }
  }
}
</script>
